import { getBookingCommentAPI } from "../../../app/api/getBookingCommentAPI";
import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IBookingCommentResponse } from "../../../Orchestrator/Types/Index";

interface IGetBookingCommentParams {
  bookingId: string;
}

class GetBookedCommentsAction extends BaseAction<IBookingCommentResponse | null, IGetBookingCommentParams> {
  override async run(): Promise<IBookingCommentResponse | null> {
    let bookingComments: IBookingCommentResponse | null = null

    try {
      const { bookingId } = this.params!;

      if (!bookingId) return null;

      const bookingCommentResponse = await getBookingCommentAPI(bookingId);
      if (bookingCommentResponse.status === "ok" && bookingCommentResponse.answer) {
        bookingComments = bookingCommentResponse.answer;
      }
    } catch (error) {
      console.error("Error in GetBookedCommentsAction:", error);
      return null
    } finally {
      updateRecoilState<IBookingCommentResponse | null>("bookedCommentsResponseAtom", bookingComments)
      return bookingComments
    }
  }
}

export const getBookedCommentsAction = new GetBookedCommentsAction();
